<template>
  <teleport to="body">
    <WdsModal v-if="show" no-close-icon :show="show" md @cancel="handleCancel">
      <template #default>
        <WdsStack direction-column gap-lg class="tw-text-center">
          <div class="tw-flex tw-justify-center">
            <div
              class="tw-w-8 tw-h-8 tw-bg-orange-100 tw-rounded-full tw-flex tw-items-center tw-justify-center"
            >
              <WdsIcon name="warning" :size="20" class="tw-text-orange-500" />
            </div>
          </div>

          <WdsStack direction-column gap-sm>
            <WdsText xl>
              {{ title }}
            </WdsText>

            <WdsText v-if="description">
              {{ description }}
            </WdsText>
          </WdsStack>
        </WdsStack>
      </template>
      <template #footer>
        <WdsStack direction-row gap-sm justify-space-between>
          <WdsButton data-test="confirmation-modal-cancel-button" @click="handleCancel">
            {{ cancelText }}
          </WdsButton>
          <WdsButton
            primary
            :loading="loading"
            data-test="confirmation-modal-confirm-button"
            @click="handleConfirm"
          >
            {{ confirmText }}
          </WdsButton>
        </WdsStack>
      </template>
    </WdsModal>
  </teleport>
</template>

<script setup lang="ts">
import { WdsButton, WdsIcon, WdsModal, WdsStack, WdsText } from '@worksome/wds-components'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

interface Props {
  show: boolean
  title: string
  description?: string
  cancelText?: string
  confirmText?: string
  loading?: boolean
}

interface Emits {
  (e: 'cancel'): void
  (e: 'confirm'): void
}

const props = withDefaults(defineProps<Props>(), {
  description: '',
  cancelText: () => $t('Cancel'),
  confirmText: () => $t('Confirm'),
  loading: false,
})

const emit = defineEmits<Emits>()

const handleCancel = () => {
  emit('cancel')
}

const handleConfirm = () => {
  emit('confirm')
}
</script>
